import { useTranslation } from "react-i18next";
import { emailStepStore } from "@/entities/StepEmail/store/emailStepStore";
import { useEffect } from "react";
import { appStore } from "@/app/store/appStore";
import { basePath } from "@/app/AppRoutes";
import { StepNavigationButtons } from "@/entities/StepNavigationButtons/StepNavigationButtons";
import { Box, Container, Image, Text } from "@mantine/core";
import CodeInput from "@/entities/StepCode/CodeInput";
import { codeStepStore } from "@/entities/StepCode/store/codeStepStore";

import styles from "./stepCode.module.scss";

export const StepCode = () => {
	const appCode = appStore((state) => state.appCode);
	const error = codeStepStore((state) => state.error);
	const code = codeStepStore((state) => state.code);
	const setCode = codeStepStore.getState().setCode;
	const responseData = emailStepStore((state) => state.responseData);
	const email = emailStepStore((state) => state.email);
	const nextBtnDisabled = !code || !!error;

	const { t } = useTranslation();

	const { startRequest, hint, logout } = emailStepStore();

	function handlePrevButton() {
		emailStepStore.getState().startRequest();
	}

	function handleNextButton() {
		setCode(code || "");
		if (!!code || !error) startRequest();
	}

	useEffect(() => {
		setCode(null);
	}, [setCode]);

	return (
		<Container className={styles.modalWrapper}>
			<Box className={styles.wrapper}>
				<Image id={`${appCode}_key`} src={`${basePath}${appCode}/key.svg`} alt="key" />
				<Text className={styles.description}>
					{t("stepCode.stepDescription", { email: (responseData?.Email || email || "").toUpperCase() })}
				</Text>
				<CodeInput setCode={setCode} onEnter={handleNextButton} />
				<Text variant="hint" >{hint}</Text>
			</Box>
			<StepNavigationButtons
				backText={t("common.back")}
				backOnClick={handlePrevButton}
				backIsDisabled={false}
				nextText={t("common.forward")}
				nextOnClick={handleNextButton}
				nextIsDisabled={nextBtnDisabled}
			/>
		</Container>
	);
};
